import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateJob } from "../hooks/queries/useJobs";
import { ROUTES } from "../constants";
import { trackFormSubmit } from "../Actions/analytics";

const useCreateJobFacade = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        title: "",
        company: "",
        location: "",
        description: "",
        detailsLink: "Not required",
        applyLink: "",
        tag: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleQuillChange = (value) => {
        setFormData({ ...formData, description: value });
    };

    const createJob = useCreateJob();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await createJob.mutateAsync(formData);
            trackFormSubmit('create_job');
            navigate(ROUTES.jobs);
        } catch (error) {
            console.error("Failed to create job:", error);
        }
    };

    return {
        formData,
        handleChange,
        handleQuillChange,
        handleSubmit,
    };
};

export default useCreateJobFacade;
